module.exports = function getResource(label, vars = []) {
    let resources = {
        myBasketLabel: 'Mon panier',
        yourBasketLabel: 'Vos paniers'
    };

    return resources[label];
};
